
import '../../css/Testops.css';
import browserstack from "../../../assets/icons/browserstack.png";
import jira from "../../../assets/icons/jira.png";
import plane from "../../../assets/icons/plane.png";
import git from "../../../assets/icons/git.png";
import python from "../../../assets/icons/python.png";
import gitlab from "../../../assets/icons/gitlab.png";

export default function Testops() {
  const tools = [
    { src: browserstack, label: "BrowserStack" },
    { src: jira, label: "Jira" },
    { src: plane, label: "Plane" },
    { src: git, label: "GitHub" },
    { src: python, label: "Python" },
    { src: gitlab, label: "GitLab" },
  ];

  return (
    <section className="testops-section">
      <div className="container">

        {/* Heading */}
        <p className="main-heading text-center mb-5">
          <span>Froth TestOps</span> integrates seamlessly without changing your working style
        </p>

        <div className="row align-items-center">

          {/* LEFT - ICON GRID */}
          <div className="col-lg-7 testopscard-mobile">
            <div className="row justify-content-center">

              {tools.map((item, index) => (
                <div className="col-6 col-sm-4 mb-4" key={index}>
                  
                  <div className="icon-box">
                    <img
                      src={item.src}
                      alt={item.label}
                      className="img-fluid icon-img"
                    />
                  </div>

                  <p className="icon-label">{item.label}</p>

                </div>
              ))}

            </div>
          </div>

          {/* RIGHT - TEXT */}
          <div className="col-lg-5 text-center text-lg-start mt-4 mt-lg-0">
            <p className="side-text">
              Link up with{" "}
              <span>GitHub, JIRA,</span>{" "}
              <span>BrowserStack</span>{" "}
              and other tools for complete traceability and defect management.
            </p>
          </div>

        </div>

      </div>
    </section>
  );
}